import { render, staticRenderFns } from "./detailMediaModal.vue?vue&type=template&id=35d2c124&"
import script from "./detailMediaModal.vue?vue&type=script&lang=js&"
export * from "./detailMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports